(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["royal-jelly-hda-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MARKER_FALLBACK = '10-HDA';

  function RjHda(root) {
    this.root = root;
    this.track = root.querySelector('[data-rj-track]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-rj-card]'));
    this.badge = root.querySelector('[data-rj-badge]');
    this.gradeLabel = root.querySelector('[data-rj-grade-label]');
    this.indicator = root.querySelector('[data-rj-indicator]');
    this.buy = root.querySelector('[data-rj-buy]');
    this.benefits = Array.prototype.slice.call(root.querySelectorAll('[data-rj-benefits] .rj-hda__benefit'));
    this.marker = root.getAttribute('data-marker') || MARKER_FALLBACK;
    this.n = this.cards.length;
    if (!this.n || !this.track) return;

    this.active = this.findFeatured();
    root.classList.add('is-enhanced');
    this.bind();
    this.render();

    var self = this;
    window.addEventListener('resize', function () { self.setHeight(); });
  }

  RjHda.prototype.findFeatured = function () {
    for (var i = 0; i < this.cards.length; i++) {
      if (this.cards[i].getAttribute('data-featured') === 'true') return i;
    }
    return Math.floor(this.n / 2);
  };

  RjHda.prototype.bind = function () {
    var self = this;
    var prev = this.root.querySelector('[data-rj-prev]');
    var next = this.root.querySelector('[data-rj-next]');
    if (prev) prev.addEventListener('click', function () { self.go(-1); });
    if (next) next.addEventListener('click', function () { self.go(1); });

    this.cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (i !== self.active) { self.active = i; self.render(); }
      });
    });

    // Touch swipe
    var x0 = null;
    this.track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) self.go(dx < 0 ? 1 : -1);
      x0 = null;
    });

    // Keyboard
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(-1); }
      else if (e.key === 'ArrowRight') { self.go(1); }
    });
  };

  RjHda.prototype.go = function (dir) {
    this.active = (this.active + dir + this.n) % this.n;
    this.render();
  };

  RjHda.prototype.position = function () {
    var n = this.n;
    var active = this.active;
    this.cards.forEach(function (card, i) {
      var off = i - active;
      if (off > n / 2) off -= n;
      if (off < -n / 2) off += n;
      var isActive = off === 0;
      card.classList.toggle('is-active', isActive);
      card.classList.toggle('is-side', !isActive);
      card.style.setProperty('--rj-off', off);
      card.style.zIndex = isActive ? 3 : 3 - Math.abs(off);
      card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  };

  RjHda.prototype.setHeight = function () {
    var activeCard = this.cards[this.active];
    if (activeCard) this.track.style.height = activeCard.offsetHeight + 'px';
  };

  RjHda.prototype.render = function () {
    this.position();
    var card = this.cards[this.active];
    var hda = card.getAttribute('data-hda') || '';
    var tier = card.getAttribute('data-tier') || '';

    if (this.gradeLabel) this.gradeLabel.textContent = this.marker + ' ' + hda;
    if (this.indicator) this.indicator.textContent = (tier ? tier + ' · ' : '') + this.marker + ' ' + hda;

    var buyUrl = card.getAttribute('data-buy-url') || '';
    var buyLabel = card.getAttribute('data-buy-label') || 'Buy';
    if (this.buy && buyUrl) {
      this.buy.href = buyUrl;
      this.buy.textContent = buyLabel;
      this.buy.hidden = false;
      if (this.indicator) this.indicator.hidden = true;
    } else {
      if (this.buy) this.buy.hidden = true;
      if (this.indicator) this.indicator.hidden = false;
    }

    if (this.badge) this.badge.hidden = card.getAttribute('data-featured') !== 'true';

    var cnt = parseInt(card.getAttribute('data-checked') || '0', 10);
    this.benefits.forEach(function (li, i) { li.classList.toggle('is-checked', i < cnt); });

    var self = this;
    window.requestAnimationFrame(function () { self.setHeight(); });
  };

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-rj-hda]:not([data-rj-init])');
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-rj-init', '1');
      new RjHda(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
